export default "/staticreactui/static/media/static/media/translator1.de062c8d.webp";